export class UserAuthorizationRoleReq{
    authRoleId: number;
    userEmail: string;
    userName: string;
    loginTypeId: number=1;
    authRoleDescription: string;
}
export enum AuthorizedActions{ ADD="add", UPDATE="update"}


// WEBPACK FOOTER //
// ./src/app/models/use-auth-role-req.ts